import { api } from '@/lib/axios';

export interface PermissionActions {
  view?: boolean;
  create?: boolean;
  edit?: boolean;
  delete?: boolean;
}

export interface Permissions {
  dashboard?: PermissionActions;
  clients?: PermissionActions;
  companies?: PermissionActions;
  tags?: PermissionActions;
  lists?: PermissionActions;
  events?: PermissionActions;
  flows?: PermissionActions;
  products?: PermissionActions;
  orders?: PermissionActions;
  venues?: PermissionActions;
  calendar?: PermissionActions;
  users?: PermissionActions;
  settings?: PermissionActions;
  emailTemplates?: PermissionActions;
  whatsapp?: PermissionActions;
}

export interface UserGroup {
  id: string;
  name: string;
  description?: string;
  permissions: Permissions;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    users: number;
  };
}

export interface CreateUserGroupDto {
  name: string;
  description?: string;
  permissions: Permissions;
  active?: boolean;
}

export interface UpdateUserGroupDto {
  name?: string;
  description?: string;
  permissions?: Permissions;
  active?: boolean;
}

export const userGroupsService = {
  async getAll(): Promise<UserGroup[]> {
    const { data } = await api.get('/user-groups');
    return data;
  },

  async getById(id: string): Promise<UserGroup> {
    const { data } = await api.get(`/user-groups/${id}`);
    return data;
  },

  async create(group: CreateUserGroupDto): Promise<UserGroup> {
    const { data } = await api.post('/user-groups', group);
    return data;
  },

  async update(id: string, group: UpdateUserGroupDto): Promise<UserGroup> {
    const { data } = await api.patch(`/user-groups/${id}`, group);
    return data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/user-groups/${id}`);
  },
};

// Lista de recursos do sistema
export const SYSTEM_RESOURCES = [
  { key: 'dashboard', label: 'Dashboard', description: 'Visualizar dashboard e estatísticas' },
  { key: 'clients', label: 'Clientes', description: 'Gerenciar clientes' },
  { key: 'companies', label: 'Empresas', description: 'Gerenciar empresas' },
  { key: 'tags', label: 'Tags', description: 'Gerenciar tags' },
  { key: 'lists', label: 'Listas', description: 'Gerenciar listas de contatos' },
  { key: 'events', label: 'Eventos', description: 'Gerenciar eventos' },
  { key: 'flows', label: 'Fluxos', description: 'Gerenciar fluxos de automação' },
  { key: 'products', label: 'Produtos', description: 'Gerenciar produtos' },
  { key: 'orders', label: 'Pedidos', description: 'Gerenciar pedidos' },
  { key: 'venues', label: 'Ambientes', description: 'Gerenciar ambientes para locação' },
  { key: 'calendar', label: 'Agenda', description: 'Acessar agenda/calendário' },
  { key: 'users', label: 'Usuários', description: 'Gerenciar usuários do sistema' },
  { key: 'settings', label: 'Configurações', description: 'Acessar configurações do sistema' },
  { key: 'emailTemplates', label: 'Templates Email', description: 'Gerenciar templates de email' },
  { key: 'whatsapp', label: 'WhatsApp', description: 'Configurar WhatsApp' },
] as const;
